/* eslint-disable import/prefer-default-export */
import ReactGA from 'react-ga';

const isDebug = (process.env.NODE_ENV === 'development') || (process.env.NODE_ENV === 'test');
const shouldLog = (process.env.NODE_ENV === 'production');

export const initializeAnalytics = () => {
  const gaTrackingId = 'UA-135301860-1';
  ReactGA.initialize(gaTrackingId, { debug: isDebug });
};

export const trackPage = (page) => {
  if (!shouldLog) { return; }

  ReactGA.pageview(page);
};

export const trackEvent = (event, args) => {
  if (!shouldLog) { return; }

  ReactGA.event({
    ...event,
    ...args,
  });
};

export const eventTypes = {
  navbarContact: {
    category: 'navbar',
    action: 'contact',
  },
  menuContact: {
    category: 'menu',
    action: 'contact',
  },
  menuApply: {
    category: 'menu',
    action: 'apply',
  },
  footerContact: {
    category: 'footer',
    action: 'contact',
  },
  footerPortfolio: {
    category: 'footer',
    action: 'see_projects',
  },
  aboutApply: {
    category: 'about',
    action: 'apply',
  },
  homeApply: {
    category: 'home',
    action: 'apply',
  },
  homeProjectsScroll: {
    category: 'home',
    action: 'scroll_to_projects',
  },
  homeProjects: {
    category: 'home',
    action: 'go_to_projects',
  },
  homePublications: {
    category: 'home',
    action: 'go_to_publications',
  },
  homePartnership: {
    category: 'home',
    action: 'go_to_industry',
  },
  projectVideoPlay: {
    category: 'project',
    action: 'play_video',
  },
  projectVideoPause: {
    category: 'project',
    action: 'pause_video',
  },
  publicationLink: {
    category: 'publications',
    action: 'see_publication',
  },
  publicationStepper: {
    category: 'publications',
    action: 'page_stepper',
  },
  industryContact: {
    category: 'industry',
    action: 'contact',
  },
  contactSendSuccess: {
    category: 'contact',
    action: 'send_success',
  },
  contactSendFail: {
    category: 'contact',
    action: 'send_fail',
  },
};
